var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-aside-cart-item" }, [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _vm.isB2B
          ? _c(
              "span",
              { staticClass: "btn--product-aside btn--product-aside-alt-b2b" },
              [_vm._v("\n        " + _vm._s(_vm.engraveText) + "\n      ")]
            )
          : _c(
              "button",
              {
                staticClass: "btn--product-aside btn--product-aside-alt",
                class: { "btn--product-aside-disabled": _vm.engraveDisabled },
                attrs: {
                  type: "submit",
                  "data-test": "engravingButton",
                  disabled: _vm.engraveDisabled,
                },
                on: { click: _vm.triggerPersonalisationModel },
              },
              [_vm._v("\n      " + _vm._s(_vm.engraveText) + "\n    ")]
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }